// extracted by mini-css-extract-plugin
export default {"arrow_btns":"HorizontalSection_arrow_btns__317nH"};